import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {
  DatePickerItem,
  TextAreaItem,
} from "../../../components/forms/FormItems";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import {
  createHospitalization,
  updateHospitalization,
} from "../patientHospitalizationsSlice";
import { useSelector } from "react-redux";
import AddEntityForm from "../../../components/templates/AddEntityForm";
import { extendMoment } from "moment-range";
import Moment from "moment";
const moment = extendMoment(Moment);

const AddUpdateHospitalization = (props) => {
  const { hide, addText, mode, record, activePatient, getPatient } = props;
  const [activeEntity, setActiveEntity] = useState();
  const dispatch = useDispatch();
  const createLoading = useSelector(
    (state) => state.pendingActions["patientHospitalizations/create"]
  );
  const updateLoading = useSelector(
    (state) => state.pendingActions["patientHospitalizations/update"]
  );
  const hospitalizations = useSelector(
    (state) => state.patientHospitalization.hospitalizations
  );

  useEffect(() => {
    setActiveEntity(record);
  }, [record]);

  const onFinish = async (values) => {
    const params = {
      hospitalization: { ...values },
      branchId: activePatient.branch,
      patientId: activePatient.id,
      hospitalizationId: mode === "edit" && record ? record.id : null,
    };
    const action =
      mode === "edit"
        ? await dispatch(updateHospitalization(params))
        : await dispatch(createHospitalization(params));
    if (!action.error) {
      hide();
      getPatient(activePatient.id);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const onValuesChange = (values) => {
    setActiveEntity(values);
  };

  const disabledFromDate = (current) => {
    let overlap = false;
    const filtered =
      record && record.id
        ? hospitalizations.filter((i) => i.id !== record.id)
        : hospitalizations;
    filtered.forEach((item, i) => {
      if (
        current.within(
          moment.range(moment(item.effective_from), moment(item.effective_to))
        )
      ) {
        overlap = true;
      }
      if (activeEntity && activeEntity.effective_to) {
        const range1 = moment.range(moment(activeEntity.effective_to), current);
        const range2 = moment.range(
          moment(item.effective_from),
          moment(item.effective_to)
        );
        if (range1.overlaps(range2, { adjacent: false })) {
          overlap = true;
        }
      }
    });
    return (
      overlap ||
      (activeEntity &&
        activeEntity.effective_to &&
        current > moment(activeEntity.effective_to))
    );
  };

  const disabledToDate = (current) => {
    let overlap = false;
    const filtered =
      record && record.id
        ? hospitalizations.filter((i) => i.id !== record.id)
        : hospitalizations;
    filtered.forEach((item, i) => {
      if (
        current.within(
          moment.range(moment(item.effective_from), moment(item.effective_to))
        )
      ) {
        overlap = true;
      }
      if (activeEntity && activeEntity.effective_from) {
        const range1 = moment.range(
          moment(activeEntity.effective_from),
          current
        );
        const range2 = moment.range(
          moment(item.effective_from),
          moment(item.effective_to)
        );
        if (range1.overlaps(range2, { adjacent: false })) {
          overlap = true;
        }
      }
    });
    return (
      overlap ||
      (activeEntity &&
        activeEntity.effective_from &&
        current < moment(activeEntity.effective_from))
    );
  };

  const items = [
    {
      name: "effective_from",
      required: true,
      comp: (
        <DatePickerItem
          name="effective_from"
          category="hospitalizations"
          required={true}
          disabledDate={disabledFromDate}
          format={"L"}
        />
      ),
    },

    {
      name: "effective_to",
      comp: (
        <DatePickerItem
          name="effective_to"
          category="hospitalizations"
          disabledDate={disabledToDate}
          format={"L"}
        />
      ),
    },
    {
      name: "hospitalization_institute_id",
      required: true,
      comp: (
        <SettingsDataSelect
          name={"hospitalization_institute_id"}
          category={"hospitalizations"}
          required={true}
          settingsdataName={"system_tables/hospitalization_institutions"}
        />
      ),
    },
    {
      name: "comment",
      required: false,
      comp: (
        <TextAreaItem
          rows={4}
          name="comment"
          category="hospitalizations"
          required={false}
        />
      ),
    },
  ];

  return (
    <AddEntityForm
      formLayout={{
        labelCol: { span: 10 },
        wrapperCol: { span: 14 },
      }}
      resource="patients"
      action="editor"
      activeEntity={record}
      items={items}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onEntityValuesChange={onValuesChange}
      onDecline={onDecline}
      saveLoading={createLoading || updateLoading}
      addText={addText}
      mode={mode}
    />
  );
};

AddUpdateHospitalization.propTypes = {
  hide: PropTypes.func,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default AddUpdateHospitalization;
